import React from 'react';

function ServerError() {
  return (
    <div id="appunavailable" className="block--center">
      <img
        className="appunavailable"
        src="https://site.manheim.com/wp-content/uploads/sites/2/Page%20images/404_blue_tire_tracks_3%20short.png"
        alt="application unavailable"
      />
      <h2 className="mui-m-h">500 SERVER ERROR</h2>
      <p>
        We are sorry, the application is not responding.
        <br />
        If you need help, please email&nbsp;
        <a href="mailto:info@manheim.com">info@manheim.com</a>
        ,
        <br />
        or call&nbsp;
        <a href="tel:1-866-626-4326">1-866-626-4346</a>
        &nbsp;Mon-Sat, 8am-12am.
      </p>
    </div>
  );
}

export default ServerError;
